export default __webpack_public_path__ + "static/Apple App Store Badge-beaeda4ea47d370116f6172732b86e25.png";